module.exports = "https://cdn.dove.it/_next/static/public/assets/services/fotografie.d1fd762507ddbf704c8d085427f6aaf8.jpg";